import PageBuilderDispatcher from '../dispatcher/PageBuilderDispatcher';
import PageBuilderConstants from '../constants/PageBuilderConstants';

var PageBuilderActions = {

  /**
  * Initialize the PageBuilderStore
  *
  * @param {object} opts
  */
  init: function (opts) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.INIT,
      opts: opts
    });
  },

  /**
  * Change UI mode between compose, desktop, tablet and cell
  */

  changeMode: function (name) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.CHANGE_MODE,
      name: name
    });
  },

  /* Row Actions */

  addColumn: function (rowId, direction) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.ADD_COLUMN,
      rowId: rowId,
      direction: direction
    });
  },

  addRow: function (rowId, direction) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.ADD_ROW,
      rowId: rowId,
      direction: direction
    });
  },

  deleteColumn: function (rowId, columnId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.DELETE_COLUMN,
      rowId: rowId,
      columnId: columnId
    });
  },

  resetColumn: function (rowId, columnId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.RESET_COLUMN,
      rowId: rowId,
      columnId: columnId
    });
  },

  deleteRow: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.DELETE_ROW,
      rowId: rowId
    });
  },

  duplicateRow: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.DUPLICATE_ROW,
      rowId: rowId
    });
  },

  highlightColumn: function (rowId, columnId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.HIGHLIGHT_COLUMN,
      rowId: rowId,
      columnId: columnId
    });
  },

  highlightRow: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.HIGHLIGHT_ROW,
      rowId: rowId
    });
  },

  insertImages: function (redactor) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.INSERT_IMAGES,
      redactor: redactor
    });
  },

  insertTextVariables: function (redactor) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.INSERT_TEXT_VARIABLES,
      redactor: redactor
    });
  },

  insertForm: function (name) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.INSERT_FORM,
      name: name
    });
  },

  moveRow: function (rowId, direction) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.MOVE_ROW,
      rowId: rowId,
      direction: direction
    });
  },

  resizeColumn: function (rowId, columnId, direction) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.RESIZE_COLUMN,
      rowId: rowId,
      columnId: columnId,
      direction: direction
    });
  },

  resizeRow: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.RESIZE_ROW,
      rowId: rowId
    });
  },

  setChart(rowId, columnId, chartId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.SET_CHART,
      rowId: rowId,
      columnId: columnId,
      chartId: chartId
    });
  },

  setName(name) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.SET_NAME,
      name: name,
    });
  },

  setWidget(rowId, columnId, widgetId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.SET_WIDGET,
      rowId: rowId,
      columnId: columnId,
      widgetId: widgetId
    });
  },

  setContentType(rowId, columnId, contentType) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.SET_CONTENT_TYPE,
      rowId: rowId,
      columnId: columnId,
      contentType: contentType
    });
  },

  styleColumn: function (rowId, columnId, style) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.STYLE_COLUMN,
      rowId: rowId,
      columnId: columnId,
      style: style
    });
  },

  toggleVisibility: function (rowId, device) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.TOGGLE_VISIBILITY,
      rowId: rowId,
      device: device
    });
  },

  /* Row Menu Actions */

  openRowMenu: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.OPEN_ROW_MENU,
      rowId: rowId
    });
  },

  closeRowMenu: function (rowId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.CLOSE_ROW_MENU,
      rowId: rowId
    });
  },

  /* Editor Actions */

  blurEditor: function (rowId, columnId, content) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.BLUR_EDITOR,
      rowId: rowId,
      columnId: columnId,
      content: content
    });
  },

  focusEditor: function (rowId, columnId) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.FOCUS_EDITOR,
      rowId: rowId,
      columnId: columnId
    });
  },

  saveEditor: function (rowId, columnId, content) {
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.SAVE_EDITOR,
      rowId: rowId,
      columnId: columnId,
      content: content
    });
  },

  changeTab: function (tab){
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.CHANGE_TAB,
      tab: tab
    });
  },

  changeRoles: function (roles){
    PageBuilderDispatcher.dispatch({
      action: PageBuilderConstants.CHANGE_ROLES,
      roles: roles
    });
  },

};

export default PageBuilderActions
